export const WS_POST_CONNECTED = 'WS_POST_CONNECTED';
export const WS_PUT_CONNECTED = 'WS_PUT_CONNECTED';
export const WS_PUT_DISCONNECTED = 'WS_PUT_DISCONNECTED';
export const WS_UPDATE_STATUS = 'WS_UPDATE_STATUS';
